// import * as fixture from '../../fixture';
import { ReportingLoaderBaseConfig } from '../../base';
import { ReportChapterLoader } from './reportChapterInterface';
import { ReportChapterAggregate } from './reportChapterModel';
import { assert, keyBy } from '@varos/util-typescript';
import { useMemo } from 'react';

export function createReportChapterLoader(
    config: ReportingLoaderBaseConfig
): ReportChapterLoader {
    const { repository } = config;
    return {
        useLoad(context, props): ReportChapterAggregate {
            const chapterQuery = repository.research.chapter.useLookup(
                context,
                { id: props.content.id },
                { suspense: true }
            );
            assert(chapterQuery.status === 'success', 'expected suspense');
            const reportQuery = repository.research.report.useLookup(
                context,
                { id: chapterQuery.data.report },
                { suspense: true }
            );
            const contentQuery = repository.research.reportContent.useLookup(
                context,
                { id: props.content.id },
                { suspense: true }
            );
            assert(reportQuery.status === 'success', 'expected suspense');
            assert(contentQuery.status === 'success', 'expected suspense');
            const sourceQuery = repository.research.source.useFind(
                context,
                { stack: reportQuery.data.stack },
                { suspense: true }
            );
            assert(sourceQuery.status === 'success', 'expected suspense');
            // console.log('sourceQuery.data', sourceQuery.data);
            // console.log('contentQuery.data', contentQuery.data);

            const sources = useMemo(
                () => keyBy(sourceQuery.data, 'id'),
                [sourceQuery.data]
            );
            // console.log('sources', sources);

            const sourcesBySectionId = useMemo(() => {
                return contentQuery.data.sections.reduce((acc, section) => {
                    return {
                        ...acc,
                        [section.id]: sourceQuery.data.filter((source) =>
                            section.references.some((ref) => ref.id === source.id)
                        ),
                    };
                }, {});
            }, [sourceQuery.data, contentQuery.data]);

            // console.log('sourcesBySectionId', sourcesBySectionId);

            return {
                report: reportQuery.data,
                chapter: chapterQuery.data,
                content: contentQuery.data,
                sources: sources,
                sourcesBySectionId,
                author: {
                    id: '1',
                    name: 'Agent Susie',
                },
            };
        },
    };
}
